// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"be9baf3a","72":"aa8dfb18","268":"2863aa41","423":"6acf765d","522":"3ee50748","564":"0e5dab57"}[chunkId] + ".css";
};